import(/* webpackMode: "eager", webpackExports: ["Center"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Center/Center.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Loader"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Loader/Loader.mjs");
